import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Common } from "../../components";
import { useVideoStore } from "../../stores";

const SavedVideo = () => {
  const { t } = useTranslation("page");
  const { video } = useVideoStore();

  const renderSavedVideo = () => {
    return (
      <Grid container item direction="row" columnGap={4} rowGap={4}>
        {video.map((v) => (
          <Grid item xs={4}>
            Saved Video
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <Grid>
      <Common.SubHeading>{t("savedVideo.heading")}</Common.SubHeading>
      <Typography>{t("savedVideo.underImplementation")}</Typography>
      {video.length === 0 ? (
        <Typography> {t("savedVideo.noVideoSaved")}</Typography>
      ) : (
        renderSavedVideo()
      )}
    </Grid>
  );
};

export default SavedVideo;
